/* 将html中的image, script等标签移除 */
export default function pureHtml(html: string | undefined) {
  if (!html) {
    return ''
  }

  const reg: RegExp = /\<img\s.*?\/?\>\n?|\<script\s.*?\>\s*?\<\/script\>\n?/gi

  const finalHtml = html.replace(reg, '')
  return finalHtml
}

export function stripHtmlTags(html: string | undefined): string {
  if (!html) return ''

  // 统一使用正则表达式，确保服务端和客户端结果一致，避免 hydration 错误
  return html.replace(/<[^>]*>/g, '').trim()
}

/**
 * 移除 HTML 标签，并将常见 HTML 实体转换为对应字符，保留换行
 */
export function stripHtmlTagsAndDecode(html: string | undefined): string {
  if (!html) return ''

  let text = html

  // 1. 处理换行相关标签
  // <br>, <br/>, <br /> -> \n
  text = text.replace(/<br\s*\/?>/gi, '\n')
  // </p>, </div> -> \n (block level elements end)
  text = text.replace(/<\/(p|div|li|h[1-6])>/gi, '\n')

  // 2. 移除所有其他标签
  text = text.replace(/<[^>]*>/g, '')

  // 3. 解码常见 HTML 实体
  text = text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")

  return text.trim()
}

/**
 * 移除除了 <a> 和 <br> 标签以外的所有 HTML 标签，并将常见 HTML 实体转换为对应字符，保留换行
 */
export function stripHtmlTagsKeepLinks(html: string | undefined): string {
  if (!html) return ''

  let text = html

  // Preserve line breaks from block elements
  text = text.replace(/<\/(p|div|li|h[1-6])>/gi, '<br>')

  text = text.replace(/<(?!a\b|\/a\b|br\b|\/br\b)[^>]*>/gi, '')

  text = text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")

  return text.trim()
}
